import { noticeSegments } from '@/entities/notice/api/paths';

export const noticeRoutePaths = {
  list: {
    path: 'notice',
    fullPath: '/notice',
  },
  detail: {
    path: `notice/${noticeSegments.noticeId}`,
    fullPath: `/notice/${noticeSegments.noticeId}`,
  },
};
